import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageLayout from "../../../components/PageLayout";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to get query parameters from URL
  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    return {
      mihpayid: searchParams.get("mihpayid"),
      mode: searchParams.get("mode"),
      status: searchParams.get("status"),
      txnid: searchParams.get("txnid"),
      amount: searchParams.get("amount"),
      net_amount_debit: searchParams.get("net_amount_debit"),
      bank_ref_num: searchParams.get("bank_ref_num"),
      field1: searchParams.get("field1"),
      field2: searchParams.get("field2"),
      field3: searchParams.get("field3"),
      field7: searchParams.get("field7"),
      field8: searchParams.get("field8"),
      field9: searchParams.get("field9"),
    };
  };

  const paymentDetails = getQueryParams();

  const handleContinueShopping = () => {
    navigate("/"); // Adjust this route based on your app's structure
  };

  // Check if payment status is success
  if (paymentDetails.status !== "success") {
    return (
      <div className="payment-success-page-container">
        <div className="payment-success-card">
          <h1 className="payment-success-heading">Payment Status</h1>
          <p className="payment-success-text">Transaction status: {paymentDetails.status}</p>
          <button className="payment-continue-button" onClick={handleContinueShopping}>
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <PageLayout
      activeSideMenu="2"
      pageTitle="Place Marketing Products Order"
      header="Place Marketing Products Order"
    >
      <div className="payment-success-page-container">
        <div className="payment-success-card">
          <div className="payment-success-icon">✓</div>
          <h1 className="payment-success-heading">Payment Successful!</h1>
          <p className="payment-success-text">
            Thank you for your purchase. Your payment has been successfully processed.
          </p>

          <div className="payment-order-details">
            <h3>Payment Details</h3>
            <div className="payment-detail-item">
              <span>Transaction ID:</span>
              <span>{paymentDetails.txnid}</span>
            </div>
            <div className="payment-detail-item">
              <span>Amount:</span>
              <span>₹{parseFloat(paymentDetails.amount).toFixed(2)}</span>
            </div>
            <div className="payment-detail-item">
              <span>Payment Mode:</span>
              <span>{paymentDetails.mode}</span>
            </div>
            <div className="payment-detail-item">
              <span>Bank Reference No:</span>
              <span>{paymentDetails.bank_ref_num}</span>
            </div>
            <div className="payment-detail-item">
              <span>Status:</span>
              <span>{paymentDetails.field9}</span>
            </div>
            <div className="payment-detail-item">
              <span>Date:</span>
              <span>{new Date().toLocaleDateString()}</span>
            </div>
          </div>

          <p className="payment-confirmation-text">A confirmation SMS has been sent to your phone number.</p>

          <button className="payment-continue-button" onClick={handleContinueShopping}>
            Home
          </button>
        </div>
      </div>
    </PageLayout>
  );
};

export default PaymentSuccess;
